import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import QRCode from 'easyqrcodejs'
import { ParceirosUtil } from '@/utils'

@Component({})
export class AppQRCode extends Vue {
	@Prop({ type: Number, default: 320 }) size!: number
	@Prop({ type: String, default: '#000000' }) primaryColor!: string
	@Prop({ type: String, default: '#ffffff' }) secondaryColor!: string
	@Prop({ type: String, required: true }) value!: string
	@Prop({ type: Number }) parceiroId!: number
	downloadUrl: string = ''

	get theme() {
		if (this.parceiroId) return ParceirosUtil.getParceiroTheme(this.parceiroId)

		return null
	}

	get _primaryColor() {
		return this.theme?.primaryColor || this.primaryColor
	}

	get _secondaryColor() {
		return this.secondaryColor
	}

	get _logo() {
		return this.theme?.logo || ''
	}

	mounted() {
		var qrcode = new QRCode(this.$refs['qrcodezone'], {
			text: this.value,
			logo: this._logo,
			width: this.size,
			height: this.size,
			colorDark: this._primaryColor,
			colorLight: this._secondaryColor,
			correctLevel: QRCode.CorrectLevel.H,
			quietZone: 10,
			quietZoneColor: 'rgba(0, 0, 0, 0)',
			onRenderingEnd: (data: any, b64: any) => {
				this.downloadUrl = b64
			}
			//quietZoneColor: `${this._primaryColor}`
		})
	}

	render() {
		return <div ref="qrcodezone"></div>
	}

	download() {
		var link = document.createElement('a')
		link.download = `qr-code-empreendimento-cliente.png`
		link.href = this.downloadUrl
		link.click()
		link.remove()
	}
}

export default AppQRCode
